import { render } from "./SingleBranch.vue?vue&type=template&id=7e0ddf90"
import script from "./SingleBranch.vue?vue&type=script&lang=js"
export * from "./SingleBranch.vue?vue&type=script&lang=js"

import "./SingleBranch.vue?vue&type=style&index=0&id=7e0ddf90&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__